export default "__VITE_ASSET__DrT4NQmx__"